// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__17tv8","signatureBlock":"Footer_signatureBlock__27g1A","signature":"Footer_signature__218ZO"};